import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseActivityPanel_StatusUpdates_caseStatusHistory';

export default gql`
  query ${NAME} (
    $caseNumber: String!
  ) {
    case (
      caseNumber: $caseNumber
    ) {
      id
      createdAt
      createdBy {
        name
        email
      }
      status
      statusHistory {
        changedAt
        createdAt
        id
        newStatus
        oldStatus
        user {
          email
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/StatusUpdates/withCaseStatusHistory/caseStatusHistoryQuery.js